import dateFormat from '@/utils/dateFormat';

const columns = () => ([
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: '15%',
  },
  {
    title: 'Date created',
    dataIndex: 'addedAt',
    key: 'addedAt',
    customRender: ({ text }) => dateFormat(text, 'DD/MM/YYYY HH:MM'),
  },
  // {
  //   title: 'CSS',
  //   dataIndex: 'css',
  //   key: 'css',
  // },
  {
    title: 'Content',
    dataIndex: 'content',
    key: 'content',
  },
  {
    title: 'Desktop',
    dataIndex: 'desktop',
    key: 'desktop',
  },
  {
    title: 'Mobile',
    dataIndex: 'mobile',
    key: 'mobile',
  },
  {
    title: 'Active',
    dataIndex: 'isActive',
    key: 'isActive',
  },
  // {
  //   title: 'Copy',
  //   dataIndex: 'copy',
  //   key: 'copy',
  // },
  {
    title: 'Delete',
    dataIndex: 'delete',
    key: 'delete',
  },
]);

export default columns;
